module.exports = __webpack_public_path__ + "img/oculus_hifi_8.12a4857d.png";